const LINK_PREFIX = `/page/`;

const paginationSlugGen = (pageNum) =>
  pageNum === 0 ? "/" : `${LINK_PREFIX}${pageNum + 1}`;

module.exports = { paginationSlugGen };
